import {makeAutoObservable, observable} from 'mobx'
import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {CompanyLink} from '@client/company-link'
import {Tracking, TrackingEvent} from '@common/tracking'
import {MessageBox} from '@components/message-box'
import {createUseStore} from '@containers/hooks'
import {globals} from '@extensions/globals-base'

interface State {
  loaded: boolean
  editing: boolean
  saving: boolean
  value: string
  remoteValue: string
  error: string
}

export class CompanyInviteStore {
  state: State = {
    loaded: false,
    editing: false,
    saving: false,
    value: '',
    remoteValue: '',
    error: ''
  }

  constructor() {
    makeAutoObservable(this, {
      state: observable.shallow
    })
  }

  copy(): void {
    CompanyLink.copy()
    void Tracking.send(TrackingEvent.myCompanyClickOnCopyLink)
  }

  delete(): void {
    this.state.value = ''
    this.save()
  }

  save(): void {
    if (this.state.saving) {
      return
    }
    if (this.state.value === this.state.remoteValue) {
      this.state.loaded = true
      this.state.editing = false
      this.state.saving = false
      this.state.error = ''
      this.state.value = this.state.remoteValue
      return
    }
    this.state.saving = true
    void CompanyLink.change(this.state.value).then(({error: e}) => {
      if (e) {
        if (e === 'Incorrect link') {
          this.state.error = Lang.msg.permission.regLinkIncorrect
        } else if (e === 'Link is already taken') {
          this.state.error = Lang.msg.permission.regLinkTaken
        } else {
          MessageBox.show('Error', 'danger')
          logger.log('Error', e)
        }
      }
      this.state.saving = false
    })
  }

  setEditing(value: boolean): void {
    this.state.editing = value
  }

  setValue(value: string): void {
    this.state.value = value
  }

  upDomain(): void {
    if (globals.standalone) {
      return
    }
    this.state.loaded = CompanyLink.isLoaded()
    this.state.editing = false
    this.state.saving = false
    this.state.error = ''
    this.state.remoteValue = CompanyLink.get()
    this.state.value = this.state.remoteValue
  }
}

const [CompanyInviteContext, useCompanyInviteStore] =
  createUseStore(CompanyInviteStore)
export {CompanyInviteContext, useCompanyInviteStore}
